const English = {
  // MENU ITEMS
  routes: 'Routes',
  performance: 'Performance',
  ships: 'Ships',
  fleet: 'Fleet',
  whatIsNew: "What's New",
  aboutCovadem: 'About CoVadem',
  disclaimer: 'Disclaimer',
  selectLanguage: 'Change language',
  accountSettings: 'Account',
  signOut: 'Sign Out',
  covadem: 'CoVadem',

  // ROUTES
  today: 'Today',
  stationName: 'Station Name',
  waterLevel: 'Water Level',
  ruleOfThumb: 'Rule of thumb',
  latestUpdate: 'Latest update',
  moreInformation: 'More information',
  lowestLoadingDepth: 'Lowest loading depth',
  lowestRuleOfThumbLoadingDepth: 'Lowest rule of thumb loading depth',
  lowestWaterDepth: 'Maximum available water depth',
  currentlyNotShowingDueToFiltering: ' currently not showing due to filtering',
  from: 'From',
  to: 'To',
  passADate: 'pass a date',
  showMap: 'Show map',
  bridges: 'Bridges',
  pegels: 'Guaging station',
  lowestBridgeClearance: 'Lowest bridge clearance',
  type: 'Type',
  KM: 'KM',
  name: 'Name',
  bridgeClearance: 'Clearance',
  tendency: 'Tendency',
  routeStart: 'Route start',
  routeEnd: 'Route end',
  loadingDepth: 'Loading depth',
  loadingDepthRuleOfThumb: 'Loading depth - Rule of thumb',
  squatTrim: 'squat/trim',
  extraSafetyMargin: 'Safety margin',
  showAll: 'Show all',
  noTableData: 'There is no Table Data',
  location: 'location',
  notAvailable: 'n/a',
  sections: 'Sections',
  both: 'Both',
  showSelections: 'Show selection',
  searchNotFound: 'No results found',
  locationSearchPlaceholder: 'Search location',
  distance: 'distance',
  via: 'via',
  noRouteAvailable: 'No route available',
  selectRoute: 'Select a route',
  loading: 'Loading',
  waterLevelRepresentsValueAt: 'Water level represents value at',

  // MAP
  showTable: 'Show table',
  more: '...More',
  draft: 'Draft',

  // MAP LEGEND
  shallow: 'Shallow',
  deep: 'Deep',

  // PERFORMANCE
  emptySelection: 'Set your selection criteria above',
  clickReset: 'Click the button: "Load / reset"',
  performanceOverallTitle: 'Overall information',
  showMyPerformance: 'Show my performance',
  selectAPeriod: 'Select a period',
  selectADateAndTime: 'Select a date and time',
  period: 'Period',
  minUKCThreshold: 'Threshold',
  minUKCThresholdCM: 'Threshold (CM)',
  culture: 'en',
  /* FIXME: this is currently not used, but maybe it will be in the future with logbooks */
  // dropDownData: [
  //   { id: 'minute', name: 'Minute' },
  //   { id: 'hour', name: 'Hour' },
  //   { id: 'day', name: 'Day' },
  //   { id: 'month', name: 'Month' },
  //   { id: 'year', name: 'Year' },
  // ],
  export: 'Export',
  exportStep1: 'Choose units',
  exportStep2: 'Export',

  // PERF OVERVIEW
  // labels
  labels: {
    fuelFlowAverage: 'Avg fuel flow',
    speedAverage: 'Avg Speed',
    UKCAverage: 'Avg UKC',
    draftAverage: 'Avg Draft',
    squatAverage: 'Avg Squat',
    cargoWeightAverage: 'Avg Cargo',
  },

  // perf. summary/overall
  distanceTotal: 'Distance sailed',
  speedAverage: 'Average speed',
  fuelTotal: 'Fuel total',
  co2Total: 'CO2 total',
  UKCAverage: 'Average UKC',
  UKCMinimal: 'Minimal UKC',
  cargoWeightAverage: 'Average cargo weight',

  fuelTKm: 'Fuel',
  csv: 'CSV',
  xlsx: 'XLSX (Excel)',

  co2TotalTooltip: `CoVadem calculates CO2 emissions based on the Tank-to-Wheel (TTW) CO2 emission factor per liter of 
                    fossil diesel fuel as it can be found on {0} (2.657kg CO2/liter diesel). 
                    If your vessel uses another fuel type, other emission factors apply.`,

  // SHIPS
  ship: 'Ship',
  box: 'CoVadem Box',
  boxType: 'Box type',
  boxNumber: 'Box number',
  sensors: 'Sensors',

  sensorTypeBox: 'Box',
  sensorTypeGPS: 'GPS',
  sensorTypeHDOP: 'HDOP',
  sensorTypeCargo: 'Cargo',
  sensorTypeEcho: 'Echo',
  sensorTypeFuel: 'Fuel',

  shipData: 'Ship Data',
  shipName: 'Ship name',
  ENINumber: 'ENI number',
  shipConstructionYear: 'Construction year',
  shipLength: 'Length',
  shipWidth: 'Width',
  shipHeight: 'Height',
  shipWeight: 'Weight',
  shipMaxCargoWeight: 'Max cargo weight',
  shipMaxDraft: 'Max draft',

  sensorWorking: 'Working',
  sensorWarning: 'Warning',
  sensorError: 'Error',
  sensorUnavailable: 'Unavailable',

  // FLEET
  speed: 'Speed (km/h)',
  cargo: 'Cargo (tons)',
  tons: 'Tons',
  fuel: 'Fuel (l)',
  ukc: 'UKC (m)',

  // ACCOUNT
  email: 'Email',
  fullName: 'Name',
  companyName: 'Company name',
  signedUp: 'Signed up',
  noMeasuringShips: 'No measuring ships',
  // ships: 'Ships',

  // NOTIFICATIONS
  errorOccurred: 'An error has occurred',
  reloadPage: 'Please reload the page',
  anotherUserLoggedIn:
    'Looks like someone logged into another device with your account',
  tokenExpired: 'Looks like your login token has expired',
  logInAgain: 'Please login again to continue',
  appUpdatesMessage:
    'The CoVadem platform has been updated and improved, Please use the link to find out more.',
  errorMessage: 'An error has occured.',
  offlineMessage:
    'There is no internet connection, please check your Wifi or mobile network settings.',
  moreInfoButton: 'more info',
  retry: 'retry',
  announcementTitle: 'Failure',
  announcementMessage: `Our apologies for the fact that our dashboard is currently not providing the right values as it should. 
                        An error has occurred in our system. The problem has been solved, but it will take a couple of days to build 
                        up the correct data, so the dashboard will be able to display the correct values again.`,

  daysDurationLimit: 'The maximum allowed range is within {0} days.',

  // VALUES
  liter: 'Liter',
  ltr: 'ltr',
  literAbbreviation: 'L',
  kilogram: 'Kilogram',
  kilometer: 'Kilometer',
  km: 'Km',
  meter: 'Meter',
  meterAbbreviation: 'M',
  kilometerPerHour: 'Km/H',
  meterPerSecond: 'M/s',
  literPerHour: 'l/hr',
  gramTonKilometer: 'gr/t/km',
  literTonKilometer: 'l/t/km',

  // Export window
  expDateTimeDescription: 'Date and time (UTC)',
  expCountTotalDescription: 'Number of measurements',
  expGPSPathDescription: 'GeoJSON LineString (CSV only)',
  expDegrees: 'Degrees (0 to 360)',
  expGeoJsonPoint: 'Geojson point',
  expLatLongSingle: '1 column',
  expLatLongDouble: '2 columns',

  // OTHERS
  comingSoon: 'Coming soon',
  show: 'Show',
  moreOpt: 'Settings',
  dropDownPlaceholder: 'Select an option',
  dropDownSearchPlaceholder: 'Type to search',
  loadResetData: 'Load / reset',
  retryData: 'Retry',
  cancel: 'Cancel',

  // PAGES
  aboutCovademContent: 'For more information please visit our website at',

  // UNSPECIFIED
  map: 'Map',
  table: 'List',
  navbarRoute: 'Routes',
  navbarPerformance: 'Performance',
  navbarShip: 'Ship',
  navbarMore: 'More',
  languages: 'Languages',
  english: 'English',
  dutch: 'Nederlands',
  german: 'Deutsch',
  french: 'Français',
  startDateError: 'Start date is required',
  endDateError: 'End date is required',
  periodError: 'Period is required',
  selectedShipError: 'Please select a ship',
  dataNotAvailable: 'Data not available',
  noDataError: 'No data available for selected period',
  indicator: 'TendencyIcon',
  navNow: 'Now',
  changePeriod: 'Please change your settings',
  navDay: 'Day',
  navMonth: 'Month',
  navYear: 'Year',
  days: 'days',
  routeDetailsButton: 'show route details',
  loadingShips: 'Loading ships...',
  selectShip: 'Select your ship',
  clickLogOut: 'Click here to Logout',
  clickContinue: 'Click here to Continue',
  backHome: 'Go back to home',
  errorScreen: 'Error Screen',
  dataSharing: 'Data Sharing',
  showLowestWarnings: 'Show critical points',
  waterChartTitle: 'Water level difference',
  clearanceChartTitle: 'Bridge clearance difference',
  chartError: 'Unavailable at this moment.',
  graphNow: 'now',
  graphDay: 'd',
  unavailable: 'unavailable',
  basis: 'basis',
  stuckedButton: "I'm stuck, reload the page",
  ruleOfThumbAppliedWarningMessage:
    'Unfortunately we don’t have enough values to give an exact position for the lowest point in this section.',

  // ADVERTISEMENT
  becomeMeasuringShipTitle: 'CoVadem offers advantages for measuring ships',
  becomeMeasuringShipWarn: `You don't have any measuring ships yet, therefore we can't show any information on this page. 
                            Did you know that you are missing out on an interesting discount? The discount can amount to more than 200 euros per year!`,
  becomeMeasuringShipSubTitle: 'Measuring is knowing',
  becomeMeasuringShipDescription: `But measuring is not only done for CoVadem, or for the discount, because: measuring is knowedge! 
                                  With CoVadem you can monitor the performance (such as fuel consumption, loading, distance traveled, 
                                  emissions) over time. In this way you generate important insights that you can use to continuously improve your performance. 
                                  Insights with which you can also monitor the effect of innovations or modifications to ship or operational management! 
                                  Moreover, you can contribute to the quality of the water depth information that we generate as CoVadem.`,
  becomeMeasuringShipContact: `Want to know more, or register as a measuring vessel immediately? Contact us for the possibilities! 
                              Call +31 88-2682300 or leave your information at {0} and we will contact you as soon as possible.`,
};

export default English;
